import { Box, Grid } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router'
import CustomLabel from '../../components/CustomLabel'
import CustomTypography from '../../components/CustomTypography'
import Layout from '../../components/Layout'
import { ROUTES } from '../../shared/constants'
import { makeStyles } from '@material-ui/core'
import Circle from '../../assets/images/icons/Ellipse 301.png'
const useStyles = makeStyles((theme) => ({
  box: {
    background: '#EFF3FE',
    margin: '10px 50px',
    maxHeight: '430px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      padding: '30px 20px',
    },
  },
  label: {
    marginLeft: '15px',
    color: '#2865C0',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}))

const attendance_Reports = [
  {
    name: 'Attendance Summary Report',
    handle: ROUTES.ATTENDANCE_SUMMARY_REPORT,
    type: 'PAGE',
  },
  {
    name: 'CheckIn CheckOut Report',
    handle: ROUTES.CHECKIN_CHECKOUT_REPORT,
    type: 'PAGE',
  },
  {
    name: 'In Time Summary Report',
    handle: ROUTES.IN_TIME_SUMMARY_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Monthly Late Report',
    handle: ROUTES.MONTHLY_LATE_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Leave Report',
    handle: ROUTES.LEAVE_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Productive Time Report',
    handle: ROUTES.PRODUCTIVE_TIME_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Team Lease Dump Report',
    handle: ROUTES.TEAM_LEASE_DUMP_REPORT,
    type: 'PAGE',
  },
]

const lead_Reports = [
  {
    name: 'Lead Generation Summary Report',
    handle: ROUTES.LEAD_GENERATION_SUMMARY_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Lead Status Report',
    handle: ROUTES.LEAD_STATUS_REPORT,
    type: 'PAGE',
  },
  // {
  //   name: 'Lead Likely Closure Report',
  //   handle: ROUTES.LEAD_LIKELY_CLOSURE_REPORT
  // },
  {
    name: 'Product Category Lead Report',
    handle: ROUTES.PRODUCT_CATEGORY_LEAD_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Product Category detailed report MTD',
    handle: ROUTES.PRODUCT_CATEGORY_DETAILED_REPORT_MTD,
    type: 'PAGE',
  },
  {
    name: 'Promoter Wise Report',
    handle: ROUTES.PROMOTER_WISE_REPORT,
    type: 'PAGE',
  },
  // {
  //   name: 'TSM Report',
  //   handle: ROUTES.TSM_REPORT
  // },
  // {
  //   name: 'Outlet Wise Report',
  //   handle: ROUTES.OUTLET_WISE_REPORT
  // },
  {
    name: 'Lead Aging Report',
    handle: ROUTES.LEAD_AGING_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Lead Dump Report for Pivot',
    handle: ROUTES.LEAD_DUMP_REPORT_FOR_PIVOT,
    type: 'PAGE',
  },
  {
    name: 'TSM Detailed Report MTD',
    handle: ROUTES.TSM_DETAILED_REPORT_MTD,
    type: 'PAGE',
  },
]

const other_Reports = [
  {
    name: 'Training Report',
    handle: ROUTES.TRAINING_REPORT,
    type: 'LINK',
  },
  {
    name: 'R & R Report',
    handle: ROUTES.R_R_REPORT,
    type: 'LINK',
  },
  {
    name: 'Merhcandise Report',
    handle: ROUTES.MERCHANDISE_REPORT,
    type: 'LINK',
  },
  {
    name: 'Customer Report',
    handle: ROUTES.CUSTOMER_REPORT,
    type: 'LINK',
  },
  {
    name: 'Hygiene Improvement Report',
    handle: ROUTES.HYGIENE_IMPROVEMENT_REPORT,
    type: 'LINK',
  },
]

const incentive_Reports = [
  {
    name: 'Incentive Report',
    handle: ROUTES.INCENTIVE_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Quarterly Earning Report',
    handle: ROUTES.QUATERLY_EARNING_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Quarterly Vs Actual Achievement Report',
    handle: ROUTES.QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT,
    type: 'PAGE',
  },
]

const marketing_Reports = [
  {
    name: 'Task Update Report',
    handle: ROUTES.INCENTIVE_REPORT,
    type: 'LINK',
  },
]

const RR_Reports = [
  {
    name: 'Leader Board Report',
    handle: ROUTES.GET_LEADER_BOARD_REPORT,
    type: 'PAGE',
  },
  {
    name: 'Top Kbc Report',
    handle: ROUTES.GET_TOP_KBC_REPORT,
    type: 'PAGE',
  },
]

const general_Reports = [
  {
    name: 'Storage Report',
    handle: ROUTES.INCENTIVE_REPORT,
    type: 'LINK',
  },
]

const LD_Reports = [
  {
    name: 'Active Content Report',
    handle: ROUTES.GET_ACTIVE_CONTENT_REPORT,
    type: 'LINK',
  },
  {
    name: 'Archived Content Report',
    handle: ROUTES.GET_ARCHIEVED_REPORT,
    type: 'LINK',
  },
  {
    name: 'L&D Score Card Report',
    handle: ROUTES.GET_LEARNING_SCORE_CARD_REPORT,
    type: 'LINK',
  },
  {
    name: 'Induction Report',
    handle: ROUTES.GET_INDUCTION_REPORT,
    type: 'LINK',
  },
  {
    name: 'Content Report',
    handle: ROUTES.GET_CONTENT_REPORT,
    type: 'LINK',
  },
  {
    name: 'Quiz Report',
    handle: ROUTES.GET_QUIZ_REPORT,
    type: 'LINK',
  },
]

const audit_Reports = [
  {
    name: 'Best Score Report',
    handle: ROUTES.INCENTIVE_REPORT,
    // type: 'LINK',
  },
  {
    name: 'KBC wise Report',
    handle: ROUTES.INCENTIVE_REPORT,
    // type: 'LINK',
  },
  {
    name: 'Audit Report',
    handle: ROUTES.GET_AUDIT_REPORT,
    // type: 'LINK',
  },
  {
    name: 'Open Task Audit Report',
    handle: ROUTES.OpenAuditTaskReport,
    // type: 'LINK',
  },
  {
    name: 'Open Task POS Report',
    handle: ROUTES.OpenPosTaskReport,
    // type: 'LINK',
  },
]

const reports = [
  {
    label: 'Attendance Reports',
    value: attendance_Reports,
  },
  {
    label: 'Lead Reports',
    value: lead_Reports,
  },
  {
    label: 'Sales Reports',
    value: incentive_Reports,
  },
  // {
  //   label: 'Marketing Reports',
  //   value: marketing_Reports,
  // },
  {
    label: 'R&R Reports',
    value: RR_Reports,
  },
  {
    label: 'Audit Reports',
    value: audit_Reports,
  },
  {
    label: 'L&D Reports',
    value: LD_Reports,
  },
  // {
  //   label: 'General Reports',
  //   value: general_Reports,
  // },
]

const handleClick = (report) => {
  console.log(report)
}

export default function Report() {
  const history = useHistory()
  const classes = useStyles()
  return (
    <Layout heading="Reports" none>
      <Grid container>
        {reports.map(({ label, value }, index) => {
          return (
            <Grid item lg={3} md={5} className={classes.box} key={index}>
              <CustomTypography label={label} />
              {value.map((report, index) => {
                return (
                  <React.Fragment key={index}>
                    <br />
                    <Box display="flex">
                      <img src={Circle} alt="circle" style={{ width: '10px', height: '10px', marginTop: '6px' }} />
                      <CustomLabel label={report.name} className={classes.label} onClick={() => history.push(report.handle)} />{' '}
                    </Box>
                  </React.Fragment>
                )
              })}
            </Grid>
          )
        })}
      </Grid>
    </Layout>
  )
}
